import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const CopyBtn = styled(Button)({
  height: "28px",
  lineHeight: "28px",
  maxHeight: "28px",
  width: "80px",
  color: "#22D758",
  fontSize: 14,
  fontFamily: "Gill Sans",
  textTransform: "uppercase",
  background: "rgba(255, 255, 255, 0.1)",
  borderRadius: "8px",
  border: "none",
  "&:hover": {
    border: "none",
    background: "rgba(34, 215, 88, 0.5)",
    color: "#22D758",
  },
});
